// client/src/lib/api/products-api.ts
// ===========================================
// MÓDULO DE GESTIÓN DE PRODUCTOS
// Maneja la creación, obtención y eliminación de productos.
// ===========================================

import { apiRequest } from "./api-client";

// -------------------------------------------
// Obtener todos los productos de la tienda actual
// -------------------------------------------
// COMENTARIO: apiRequest obtiene la respuesta JSON completa.
// Como el backend devuelve { products: [...] }, extraemos solo el array
// para mantener la compatibilidad con el frontend existente.
export async function getProducts(): Promise<any[]> {
  const response = await apiRequest<{ products: any[] }>("/api/products");
  return response.products;
}

// -------------------------------------------
// Crear un nuevo producto en una tienda
// -------------------------------------------
// COMENTARIO: Eliminamos los múltiples console.log y el manejo manual de errores
// (como error.status = res.status). La función apiRequest ya lanza un error tipado
// (ApiError) que incluye el status y los datos del backend automáticamente.
export async function createProduct(
  shopId: string,
  productData: {
    name: string;
    category: string;
    price: string;
    stock: number;
    threshold: number;
    supplierId?: string;
    supplierNotes?: string;
    acquisitionCost?: string;
    profitMargin?: string;
    batchNumber?: string;
    purchaseDate?: string;
    expiryDate?: string;
    minimumOrderQuantity?: number;
    leadTimeDays?: number;
    dailySalesRate?: string;
    reorderPoint?: number;
  },
): Promise<any> {
  return apiRequest<any>(`/api/shops/${shopId}/products`, {
    method: "POST",
    body: JSON.stringify(productData),
  });
}

// -------------------------------------------
// Eliminar un producto
// -------------------------------------------
// COMENTARIO: Simplemente llamamos al endpoint DELETE.
// Si falla, apiRequest lanza el error; si funciona, retorna undefined (Promise<void>).
export async function deleteProduct(productId: string): Promise<void> {
  return apiRequest<void>(`/api/products/${productId}`, {
    method: "DELETE",
  });
}
